import { find } from 'lodash'

export function generateErrorMessage(error) {
	let errorMessage = '';
	if(error.response !== undefined){
		if(error.response.status == 422){
			errorMessage = formatValidationError(error.response.data)
		}else if (error.response.data.message) {
			errorMessage = error.response.data.message
			if(errorMessage === 'UNDERWRITER API ERROR'){
				errorMessage = 'Apologies! We are unable to connect to our underwriters at the moment, please try again later.';
			}
		}
	}
	if(typeof error === 'string')
	{
		errorMessage = error
	}
	return errorMessage
}

export function formatValidationError(validationErrors = {})
{
	let template = `
		<div class="alert alert-warning" role="alert">
			<ul>`

	Object.keys(validationErrors['errors']).forEach(function (key) {
		template += `<li>${validationErrors['errors'][key]}</li>`
	});

	template += `</ul>
		</div>
	`
	return template
}

/**
 * Get the value of a querystring
 * @param  {String} field The field to get the value of
 * @param  {String} url   The URL to get the value from (optional)
 * @return {String}       The field value
 */
export function getQueryString ( field, url = false) {
    var href = url ? url : window.location.href;
    var reg = new RegExp( '[?&]' + field + '=([^&#]*)', 'i' );
    var string = reg.exec(href);
    return string ? string[1] : null;
};

export function getAbsolutePath() {
	var loc = window.location;
	var pathName = loc.pathname.substring(0, loc.pathname.lastIndexOf('/') + 1);
	return loc.href.substring(0, loc.href.length - ((loc.pathname + loc.search + loc.hash).length - pathName.length));
}

// ==================================================================================
// Fallback ES5 for IE
if (!String.prototype.endsWith) {
	String.prototype.endsWith = function(searchStr, Position) {
		// This works much better than >= because
		// it compensates for NaN:
		if (!(Position < this.length)) {
			Position = this.length;
		} else {
			Position |= 0; // round position
		}

		return this.substr(Position - searchStr.length, searchStr.length) === searchStr;
	}
}
if (!String.prototype.startsWith) {
	String.prototype.startsWith = function(searchString, position){
		return this.substr(position || 0, searchString.length) === searchString;
	}
}
// ==================================================================================

/**
 * Function check if current development env is dev or not by domain name.
 */
export function isDevEnv()
{
		const hostname = window.location.hostname
    return (
			hostname.endsWith('.dev') ||
			hostname.endsWith('.test')
		)
}

export function isStagingEnv()
{
    return window.location.hostname.startsWith('staging')
}

export function isProductionEnv()
{
    return window.location.hostname.startsWith('portal')
}


export function isStagingWPEnv()
{
    return window.location.hostname.startsWith('pli')
}


export function requireHeatWorkPercentage (occupationId, occupations = []) {
	if (!occupationId) {
		return true;
	}

	let occupation = find(occupations, o => o.id == occupationId)
	if (!occupation || !occupation.hasOwnProperty('heat_work_percentage')) {
		return true;
	}

	return Boolean(occupation.heat_work_percentage)
}

export function formValidate (fields, required = {}) {
	const errors = {}

	if (fields.hasOwnProperty('current_annual_revenue')) {
		const currentAnnualRevenue = Number(fields.current_annual_revenue) || 0
		if (currentAnnualRevenue < 0) {
			errors.current_annual_revenue = {
				out_of_range: true
			}
		}
	}

	if (fields.hasOwnProperty('postcode_of_risk')) {
		const postcodeOfRisk = Number(fields.postcode_of_risk) || 0
		if (!_.inRange(postcodeOfRisk, 100, 9999)) {
			errors.postcode_of_risk = {
				out_of_range: true
			}
		}
	}

	if (fields.hasOwnProperty('email')) {
		if (fields.email && !/\S+@\S+\.\S+/.test(fields.email)) {
			errors.email = {
				format: true
			}
		}
	}

	Object.keys(fields)
		.forEach(key => {
			if (required.hasOwnProperty(key) && !required[key]) {
				return
			}

			const value = fields[key]
			const type = typeof value

			switch (key) {
				case 'percentage_of_insured_turnover_from_premises':
					if (value == '>5') {
						errors[key] = errors[key] || {}
						errors[key]['quote_rejected'] = true
					}
					break
				case 'head_count':
					if (value == '11') {
						errors[key] = errors[key] || {}
						errors[key]['quote_rejected'] = true
					}
					break
			}

			if (value === '' || type === 'undefined' || (type === 'number' && isNaN(value))) {
				errors[key] = errors[key] || {}
				errors[key]['required'] = true
			}
		})

	return errors
}
